<template>
  <v-flex class="cStatement" data-qa="consolidatedstatement-flex-m6ti43">
    <Loader v-show="loaderEnabled"/>
    <v-layout wrap class="ml-2 cStatement--gradientBGposition" data-qa="consolidatedstatement-layout-9gt0pw">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient, height: '180px' }"
       data-qa="consolidatedstatement-flex-xdsq9c">
        <v-container class="cStatement--title-padding" data-qa="consolidatedstatement-container-ea47re">
          <v-flex xs12 sm12 md12 lg12 xl12 data-qa="consolidatedstatement-flex-v9hptc">
            <v-row no-gutters data-qa="consolidatedstatement-row-7m1o8">
              <v-layout row wrap class="pb-2" data-qa="consolidatedstatement-layout-ajvuhb">
                <v-flex xs2 sm2 md2 lg1 xl1 class="pr-6 pt-4" data-qa="consolidatedstatement-flex-24v5jd">
                  <v-row justify="end" data-qa="consolidatedstatement-row-mwbwz">
                    <v-avatar :tile="false" size="35" color="white" data-qa="consolidatedstatement-avatar-oz842">
                      <v-icon :color="primaryColor" data-qa="consolidatedstatement-icon-ouhz1m">mdi-file-document</v-icon>
                    </v-avatar>
                  </v-row>
                </v-flex>
                <v-flex xs9 sm9 md9 lg9 xl9 class="pt-4" data-qa="consolidatedstatement-flex-krgnv">
                  <v-row no-gutters data-qa="consolidatedstatement-row-0ljn9i">
                    <font class="text-h5 font-weight-light white--text">
                      {{ $t("consolidatedStatement.title") }}</font
                    >
                  </v-row>
                </v-flex>
              </v-layout>
            </v-row>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>
    <v-flex xs12 sm12 md12 lg10 xl10 class="cStatement--content-padding cStatement--overlayCardFlex" data-qa="consolidatedstatement-flex-p2o91gi">
      <v-layout row wrap class="cStatement--content-padding" data-qa="consolidatedstatement-layout-qepzx">
        <v-flex xs12 sm11 md10 lg10 xl10 class="pt-4" data-qa="consolidatedstatement-flex-p2chn8">
          <v-card data-qa="consolidatedstatement-card-pbuv3">
            <v-container data-qa="consolidatedstatement-container-alyxf">
              <!-- Show OptIn -->
              <v-row
                v-if="!showOptInStatement"
                no-gutters
                justify="start"
                class="ma-6"
               data-qa="consolidatedstatement-row-imhpo">
                <v-sheet outlined class="text-center pt-4" color="#FAFAFA" data-qa="consolidatedstatement-sheet-7gmn4">
                  <v-layout data-qa="consolidatedstatement-layout-ihqbg">
                    <v-flex xs2 sm2 md2 lg2 xl2 data-qa="consolidatedstatement-flex-ad7gzi">
                      <v-icon color="#E0E0E0" size="60" data-qa="consolidatedstatement-icon-owkg6q">mdi-file-document</v-icon>
                    </v-flex>
                    <v-flex xs10 sm10 md10 lg10 xl10 data-qa="consolidatedstatement-flex-3lgyxf">
                      <span class="ma-3" data-qa="consolidatedstatement-span-qm2aub">
                        {{ $t("consolidatedStatement.optInContent") }}
                      </span>
                    </v-flex>
                  </v-layout>
                  <br data-qa="consolidatedstatement-br-30a18" />
                  <v-layout justify="center" data-qa="consolidatedstatement-layout-uylxva">
                    <v-flex xs12 sm12 md6 lg7 xl7 class="pa-1 pb-4" data-qa="consolidatedstatement-flex-mywm9f">
                      <v-btn
                        @click="goToSettings"
                        :color="primaryColor"
                        class="text-capitalize white--text py-2 px-4"
                         data-qa="consolidatedstatement-btn-yjoq86">{{ $t("consolidatedStatement.optInBtn") }}</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-sheet>
              </v-row>
              <!-- Show Confirm OptIn Message-->
              <v-row
                v-if="showConfirmOptIn"
                no-gutters
                justify="center"
                class="ma-6"
               data-qa="consolidatedstatement-row-e2i5cj">
                <v-sheet outlined class="text-center pa-6" color="#FAFAFA" data-qa="consolidatedstatement-sheet-q1n3d">
                  <inline-svg
                    :src="getTickIcon()"
                    width="100"
                    height="100"
                    aria-label="Tick Icon"
                  ></inline-svg>
                  <p class="ma-6 mt-0 px-12" data-qa="consolidatedstatement-p-7c9rgu">
                    {{ $t("consolidatedStatement.optInConfirmMsg") }}
                  </p>
                </v-sheet>
              </v-row>
              <!-- Show Opt Out -->
              <v-row
                v-if="showOptOutStatement"
                no-gutters
                justify="start"
                class="px-3"
               data-qa="consolidatedstatement-row-8rna3">
                <v-layout class="pa-3 pb-4" data-qa="consolidatedstatement-layout-alcfb">
                  <v-flex xs12 sm12 md12 lg9 xl9 class="font-weight-regular" data-qa="consolidatedstatement-flex-nw6dgo">
                    {{ $t("consolidatedStatement.optOutContent") }}
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg3 xl3 data-qa="consolidatedstatement-flex-pn04yi">
                    <v-btn
                      @click="goToSettings"
                      :color="primaryColor"
                      outlined
                      class="text-capitalize py-2 px-4"
                       data-qa="consolidatedstatement-btn-31h14">{{ $t("consolidatedStatement.optOutBtn") }}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-row>
              <v-divider data-qa="consolidatedstatement-divider-4vyrme"  v-if="eStatementList.length" class="pa-1" />
              <!-- List the statements -->
              <v-list v-if="eStatementList.length" class="px-5" data-qa="consolidatedstatement-list-416rqx">
                <v-list-item-content
                  v-for="(statement, index) in eStatementList"
                  :key="index"
                 :data-qa="`consolidatedstatement-list-item-content-9o1568-${index}`">
                  <v-card-text class="pa-2" :data-qa="`consolidatedstatement-card-text-ab4c9-${index}`">
                    <v-layout wrap :data-qa="`consolidatedstatement-layout-h3awxg-${index}`">
                      <v-flex xs12 sm12 md12 lg7 xl7 :data-qa="`consolidatedstatement-flex-epamb-${index}`">
                        <span
                          class="body-1 font-weight-regular"
                          v-text="statement.data"
                          :data-qa="`consolidatedstatement-span-rfezzs-${index}`"></span>
                      </v-flex>
                      <v-flex xs12 sm12 md12 lg5 xl5 :data-qa="`consolidatedstatement-flex-3211kq-${index}`">
                        <v-btn
                          @click="downloadStatement('view', statement.documentId)"
                          text
                          :color="primaryColor"
                          class="text-capitalize py-2 px-4"
                          :data-qa="`consolidatedstatement-btn-f5ysdn-${index}`">
                          <v-icon left class="material-symbols-outlined" :data-qa="`consolidatedstatement-icon-3bql3h-${index}`">visibility</v-icon>
                          <font class="body-2 font-weight-regular">
                          {{
                            $t("consolidatedStatement.viewBtn")
                          }}</font>
                        </v-btn>
                        <v-btn
                          @click="downloadStatement('download', statement.documentId)"
                          text
                          :color="primaryColor"
                          class="text-capitalize py-2 px-4"
                          :data-qa="`consolidatedstatement-btn-8n23dk-${index}`">
                          <v-icon left class="material-symbols-outlined" :data-qa="`consolidatedstatement-icon-dhxew-${index}`">download</v-icon>
                          <font class="body-2 font-weight-regular">{{
                            $t("consolidatedStatement.downloadBtn")
                          }}</font>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-divider :data-qa="`consolidatedstatement-divider-nkv72d-${index}`"  v-if="!(index === eStatementList.length - 1)" />
                </v-list-item-content>
              </v-list>
              <v-row v-if="(showOptInStatement && !eStatementList.length && noStatementsAvail)" no-gutters justify="center" class="ma-6" data-qa="consolidatedstatement-row-bypo3">
                <v-sheet outlined class="text-center pa-6" color="#FAFAFA" data-qa="consolidatedstatement-sheet-5wduep">
                  <p class="ma-6 mt-0 px-12" data-qa="consolidatedstatement-p-yrxsi">
                    {{ $t("consolidatedStatement.noStatementsAvailable") }}
                  </p>
                </v-sheet>
              </v-row>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <!-- Doc preview -->
    <PDFPreview v-if="viewPDF" :PDFData="PDFData" @closePdfPreview="viewPDF= false"/>
  </v-flex>
</template>

<script>
import '@/styles/pages/consolidatedStatement.scss'
import store from '@/core/store'
import preload from '@/util/preload'
import CommonService from '@/service/commonService.js'
import Loader from '../../components/common/Loader.vue'
import PDFPreview from '@/components/common/PDFPreview.vue'

export default {
  name: 'ConsolidatedStatement',
  components: {
    Loader,
    PDFPreview
  },
  data () {
    return {
      loaderEnabled: false,
      showOptInStatement: false,
      showOptOutStatement: false,
      showConfirmOptIn: false,
      noStatementsAvail: false,
      statementDoc: undefined,
      eStatementList: [],
      viewPDF: false,
      PDFData: undefined
    }
  },
  created () {
    this.getListOfDocStatements()
  },
  methods: {
    getTickIcon () {
      return this.getSvgIconSrc('Tick')
    },
    async getListOfDocStatements () {
      const { isConsolidateStatementRequired } = store.getters[
        'profileStore/profileData'
      ].customerDetails
      this.showOptInStatement = isConsolidateStatementRequired
      this.showOptOutStatement = isConsolidateStatementRequired
      this.loaderEnabled = true
      const details = {
        businessType: 'PARTY',
        businessValue: JSON.parse(sessionStorage.getItem('username')),
        documentType: 'INTEGRATED-STATEMENT'
      }
      const response = await CommonService.getListOfCustomerConsolidatedStatements(details)
      if (response && response?.length > 0) {
        this.eStatementList = []
         response.forEach((item) => {
          if (item?.fromDate && item?.toDate) {
            const fromDate = this.$formatter.formatDate(item?.fromDate)
            const toDate = this.$formatter.formatDate(item?.toDate)
            this.eStatementList.push({
              data: `${fromDate.replaceAll(
                '-',
                '/'
              )} - ${toDate.replaceAll('-', '/')}`,
              documentId: item.documentId
            })
          }
        })
      } else {
        this.eStatementList = []
        this.noStatementsAvail = true
      }
      this.loaderEnabled = false
    },
    async downloadStatement (type, documentId) {
      const body = {
        businessType: 'PARTY',
        businessValue: JSON.parse(sessionStorage.getItem('username')),
        documentType: 'INTEGRATED-STATEMENT'
      }
      const response = await CommonService.downloadCustomerConsolidatedStatementDocument(documentId, body)

      if (response && !response.causes) {
        const userLoginId = sessionStorage.getItem('userId')
          ? JSON.parse(sessionStorage.getItem('userId'))
          : JSON.parse(sessionStorage.getItem('username'))
        const fileName = `E-Statement-${userLoginId}.pdf`
        // const blobObject = new Blob([response], { type: 'application/pdf' })
        // const fileURL = window.URL.createObjectURL(blobObject)
        if (type === 'view') {
          this.PDFData = response
          this.viewPDF = true
        } else {
          if (response && !response.causes) { // positive response
            // this.downloadFile(fileURL, fileName)
            var a = document.createElement('a') // Create <a data-qa="consolidatedstatement-a-1bvg2">
            a.href = response // Image Base64 Goes here
            a.download = fileName
            a.click()
          }
        }
      }
    },
    downloadFile (file, fileName) {
      var link = document.createElement('a')
      link.href = file
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    goToSettings () {
      this.$router.push('/settings')
    },
    async optInConsolidatedStatement (optIn) {
      try {
        store.dispatch('profileStore/setProfileData', {
          isConsolidateStatementRequired: optIn,
          isCStatementOpted: true
        })
        const response = await CommonService.amendCustomerDetails()
        if (response) {
          if (optIn) {
            this.showOptInStatement = true
            this.showConfirmOptIn = true
            this.noStatementsAvail = false
            this.showOptOutStatement = false
          } else {
            this.showOptInStatement = false
            this.showOptOutStatement = false
            this.showConfirmOptIn = false
          }
          const { get } = this
          const isSmeLogin = get('isSmeLogin') || false
          const customerCode = get('customerCode') || ''
          // fetch customer details API call
          preload.getCustomerDetails(isSmeLogin ? customerCode : get('username'))
        }
      } catch (e) {
        console.log(e)
      }
    }
  },
  get: (k) => JSON.parse(sessionStorage.getItem(k))
}
</script>
